/* DailyJocks — no-drawer add-to-cart confirmation. Shopify cart/add.js is the source of truth. */
(function () {
  'use strict';
  var ui = document.getElementById('dj-cart-confirmation');
  if (!ui) return;
  var itemEl = ui.querySelector('[data-dj-cart-item]');
  var shopEl = ui.querySelector('[data-dj-cart-shop-more]');
  var checkoutEl = ui.querySelector('[data-dj-cart-checkout]');
  var root = ui.getAttribute('data-dj-root') || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';
  checkoutEl.href = root + 'checkout';

  // Only link to an existing, Shopify-assigned collection. Never make up collection slugs.
  var categories = [
    { name: 'swimwear', terms: ['swim', 'swimsuit', 'swimwear'] },
    { name: 'jockstraps', terms: ['jockstrap', 'jock'] },
    { name: 'thongs', terms: ['thong', 'g-string', 'gstring'] },
    { name: 'briefs', terms: ['brief'] },
    { name: 'trunks', terms: ['trunk', 'boxer'] },
    { name: 'shorts', terms: ['short'] },
    { name: 'skirts', terms: ['skirt'] },
    { name: 'singlets', terms: ['singlet', 'tank'] },
    { name: 'socks', terms: ['sock'] }
  ];
  function norm(x) { return String(x || '').toLowerCase().replace(/[^a-z0-9-]+/g, '-'); }
  function matchTerm(input, terms) { return terms.some(function (t) { return input.indexOf(t) !== -1; }); }
  function getCategory(type, title, handles) {
    var combined = norm(type) + ' ' + norm(title);
    var collectionHandles = String(handles || '').split(',').map(function (h) { return h.trim().toLowerCase(); }).filter(Boolean);
    var category = categories.find(function (cat) { return matchTerm(combined, cat.terms); });
    if (!category) return null;
    var handle = collectionHandles.find(function (h) { return h === category.name; }) ||
      collectionHandles.find(function (h) { return matchTerm(h, category.terms) && !/(sale|clearance|discount|outlet|bundle)/.test(h); });
    return handle ? { name: category.name, url: root + 'collections/' + encodeURIComponent(handle) } : null;
  }
  function show(opts) {
    opts = opts || {};
    var item = opts.item || {};
    var title = item.product_title || item.title || opts.productTitle || 'Item';
    var variant = item.variant_title || '';
    var detail = title;
    if (variant && variant !== 'Default Title' && title.indexOf(variant) === -1) detail += ' · ' + variant.replace(/ \/ /g, ' · ');
    itemEl.textContent = detail;
    var category = getCategory(opts.productType, title, opts.collectionHandles);
    if (category) {
      shopEl.textContent = 'Shop more ' + category.name + ' →';
      shopEl.href = category.url;
      shopEl.hidden = false;
    } else {
      shopEl.hidden = true;
      shopEl.removeAttribute('href');
    }
    ui.hidden = false;
    // Cart refresh is independent of success UI: a failing section or cart.js must not hide confirmation.
    refreshCount();
  }
  function close() { ui.hidden = true; }
  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('Cart count unavailable'); return r.json(); })
      .then(function (cart) {
        var link = document.getElementById('cart-icon-bubble');
        if (!link) return;
        var count = Number(cart.item_count || 0);
        var bubble = link.querySelector('.cart-count-bubble');
        if (!count) { if (bubble) bubble.remove(); return; }
        if (!bubble) { bubble = document.createElement('div'); bubble.className = 'cart-count-bubble'; link.appendChild(bubble); }
        bubble.replaceChildren();
        if (count < 100) { var number = document.createElement('span'); number.setAttribute('aria-hidden', 'true'); number.textContent = count; bubble.appendChild(number); }
        var screen = document.createElement('span'); screen.className = 'visually-hidden'; screen.textContent = count + ' items in cart'; bubble.appendChild(screen);
      })
      .catch(function (err) { console.warn('Cart confirmation: could not update header count', err); });
  }
  ui.querySelector('[data-dj-cart-close]').addEventListener('click', close);
  shopEl.addEventListener('click', function (ev) {
    // Do not reload current filtered collection or lose scroll position.
    if (this.href && new URL(this.href).pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '')) {
      ev.preventDefault(); close();
    }
  });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !ui.hidden) close(); });
  window.DJCartConfirmation = { show: show, close: close, refreshCount: refreshCount };
})();
